import { z } from 'zod';
import { JobApi } from '../../../Jobs/JobApi';
import { get } from 'svelte/store';
import { api } from '../../../../../stores/api';

export const AutoSuggesterRequestSchema = z.object({
    fldName: z.string(),
    query: z.string(),
    maxItems: z.number(),
});
export interface AutoSuggesterRequestType extends z.infer<typeof AutoSuggesterRequestSchema> {}

export const AutoSuggesterResponseSchema = z.object({
    status: z.literal(1),
    fldName: z.string(),
    maxItems: z.number(),
    query: z.string(),
    items: z.array(z.string()),
});
export interface AutoSuggesterResponseType extends z.infer<typeof AutoSuggesterResponseSchema> {}

export class featureAutoSuggester {
    public static async getSuggestions(request: AutoSuggesterRequestType, asyncSource: string) {
        // add asyncSource to request
        request = {
            ...request,
            asyncSource: asyncSource,
        };
        return JobApi.getSuggestions(
            get(api),
            featureAutoSuggester.convertRequestToURLSearchParams(request)
        );
    }

    // public static async getSuggestions(request: AutoSuggesterRequestType): Promise<AutoSuggesterResponseType> {
    //     return new Promise((resolve, reject) => {
    //         try {
    //             AutoSuggesterRequestSchema.parse(request);
    //         } catch (error) {
    //             console.debug('AutoSuggesterRequestSchema.parse request', request);
    //             console.error('AutoSuggesterRequestSchema.parse error', error.message);
    //             reject('Błąd na wejściu danych (getSuggestions) ' + error);
    //         }
    //         fetch('./api/jobs/suggest?' + featureAutoSuggester.convertRequestToURLSearchParams(request), {
    //             method: 'GET',
    //         }).then((response) => {
    //             return response.json();
    //         }).then((data: AutoSuggesterResponseType) => {
    //             try {
    //                 AutoSuggesterResponseSchema.parse(data);
    //             } catch (error) {
    //                 console.debug('AutoSuggesterResponseSchema.parse request', request);
    //                 console.debug('AutoSuggesterResponseSchema.parse response', data);
    //                 console.error('AutoSuggesterResponseSchema.parse error', error.message);
    //                 reject('Error zod: ' + error.message);
    //             }
    //             if (data.status !== 1) {
    //                 reject('Nie udało się pobrać danych z serwera. Spróbuj ponownie później');
    //             } else {
    //                 resolve(data);
    //             }
    //         }).catch((error) => {
    //             console.error('featureAutoSuggester, getSuggestions, error', error);
    //             reject(error);
    //         });
    //     });
    // }
    //
    public static convertRequestToURLSearchParams(request: AutoSuggesterRequestType): string {
        return new URLSearchParams(featureAutoSuggester.convertRequestToString(request)).toString();
    }

    private static convertRequestToString(request: AutoSuggesterRequestType): {
        [key: string]: string;
    } {
        // convert all values from request to string and save as new object
        let requestConvertedToString: { [key: string]: string } = {};
        Object.keys(request).forEach(key => {
            requestConvertedToString[key] = request[key].toString();
        });
        return requestConvertedToString;
    }
}
